import { type AttrTrackingMap } from '@unisporkal/attr-tracking';

export const assetAcquisitionAttrTrackingMap: AttrTrackingMap = {
  mfeId: 'asset-acquisition',
  events: {},
};

// A constant, not built per call: AttrTrackingProvider re-registers on identity.
const EMPTY_MAP: AttrTrackingMap = {
  mfeId: assetAcquisitionAttrTrackingMap.mfeId,
  events: {},
};

export const getAttrTrackingMap = (isFlagEnabled = false) =>
  isFlagEnabled ? assetAcquisitionAttrTrackingMap : EMPTY_MAP;
